/* eslint-disable no-useless-escape */
import { 
  API_URL, CartItemTypes, FAIR_MARKET, SubIntervalMap, CRYPT_TO_SYMBOLS, 
  VALID_PRICE_TIME, VALID_PRICE_DIFFER_PERCENT, NORMAL_CONVERSION_SPREAD,
  WEEKEND_CONVERSION_SPREAD,
 } from "../constants";

export const parseJSONResponse = (response) => {
  return new Promise((resolve) => {
    return response
      .json()
      .then((json) =>
        resolve({
          status: response.status,
          ok: response.ok,
          json,
        })
      )
      .catch((error) =>
        resolve({
          status: response.status,
          ok: false,
          json: {
            message: response.statusText,
          },
        })
      );
  });
};

export const asyncCheck = async (field, value) => {
  const body = {};

  if (field === 'email') body.email = value ? value.trim() : "";
  else if (field === 'username') body.username = value ? value.trim() : "";

  try {
    const response = await fetch(`${API_URL}/account/check`, {
      credentials: 'include', method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    
    const result = await response.json();

    return result;
  } catch (error) {
    console.error(error);
    return error
  }
};

export const createLead = async (data) => {
  return await fetch(`${API_URL}/order/step-one`, {
    credentials: 'include', method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then(parseJSONResponse)
    .then(({ json }) => json);
};

export const handleStepTwo = async (data) => {
  return await fetch(`${API_URL}/order/step-two`, {
    credentials: 'include', method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then(parseJSONResponse)
    .then(({ json }) => json)
};

export const onReturnKeyPress = (event, cb) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    event.stopPropagation();
    if (cb && typeof cb === 'function') cb(event);
    else console.warn('Return key pressed but no function was passed to trigger');
  }
}

//**************************** NEW UTILS */
export const formatPrice = (price) => {
  let returnedPrice = Math.round(price * 100) / 100;

  if(returnedPrice.toString().includes('.')) {
    let {0: left, 1: right} = returnedPrice.toString().split('.');
    if(right.length === 1) {
      if(right === "0") right = "";
      else right = `${right}0`;
    } else if(right.length > 2) {
      let rightArray = Array.from(right);
      right = rightArray.reduce((final, char, i) => {
        if(i === 0) final += char;
        else if(i === 1 ) {
          if(char === "0") final += "1"
          else final += char;
        }
        return final;
      }, "")
    }

    returnedPrice = right !== "" && Number(right) !== 0 ? `${left}.${right}` : `${left}`;
  }

  return returnedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// returns ordinal suffix of a number in string
export const getNumberWithOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const isPopUpAllowed = async () => {
  try {
    const popup = window.open('https://www.google.com');
    if (popup == null || typeof(popup) === 'undefined') return false
  } catch (error) {
    
  }
}

function _hasPopupBlocker(poppedWindow) {
  var result = false;

  try {
    if (typeof poppedWindow == 'undefined') {
      // Safari with popup blocker... leaves the popup window handle undefined
      result = true;
    }
    else if (poppedWindow && poppedWindow.closed) {
      // This happens if the user opens and closes the client window...
      // Confusing because the handle is still available, but it's in a "closed" state.
      // We're not saying that the window is not being blocked, we're just saying
      // that the window has been closed before the test could be run.
      result = false;
    }
    else if (poppedWindow && poppedWindow.test) {
      // This is the actual test. The client window should be fine.
      result = false;
    }
    else {
      // Else we'll assume the window is not OK
      result = true;
    }

  } catch (err) {
    console.warn("Could not access popup window", err);
  }

  return result;
}

export const openNewWindow = (w = 580, h = 540) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft
  const top = (height - h) / 2 / systemZoom + dualScreenTop
  const newWindow = window.open('', 'TVI - PayPal Authorize', 
    `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
  );

  if (!_hasPopupBlocker(newWindow)) return { error: '_Please turn off your pop-up blocker to pay via PayPal' };

  if (newWindow == null || typeof(newWindow) === 'undefined') return { error: '_Please turn off your pop-up blocker to pay via PayPal' };

  if (window.focus) newWindow.focus();

  return newWindow;
}

export const titleCaseStr = (str) => str.split('_').map(s => `${s.substr(0, 1).toUpperCase()}${s.substr(1).toLowerCase()}`).join(' ');

export const mapForCart = ({ modelId, onModel, paidFor }) => {
  const { name, price, _id, interval, items, trialPeriod } = modelId;
  let cartItem = { name, price, _id, type: onModel, paidFor, trialPeriod };

  if (onModel === CartItemTypes.subscriptionPlan) {
    cartItem['interval'] = interval;
    cartItem['trialPeriod'] = trialPeriod;
  }
  else if (onModel === CartItemTypes.customOffer) {
    let hasSubscription = false;
    cartItem['items'] = items.map(({ modelId, onModel }) => {
      if (onModel === CartItemTypes.subscriptionPlan) hasSubscription = true;
      return ({ name: modelId.name, price: modelId.price, _id: modelId._id, interval: modelId.interval, type: onModel });
    });

    cartItem['hasSubscription'] = hasSubscription;
  }


  return cartItem;
};

export const getProductType = (abbr) => {
  switch (abbr) {
    case 'p':
      return CartItemTypes.product;
    
    case 'pp':
      return CartItemTypes.productPackage;
    
    case 's':
      return CartItemTypes.subscriptionPlan;
  
    case 'c':
      return CartItemTypes.customOffer;
  
    default:
      return null;
  }
}

export const extractSubscription = (cart = []) => cart.filter(({ type }) => type === CartItemTypes.subscriptionPlan);
export const hasSubscription = (cart = []) => extractSubscription(cart).length > 0;

export const extractCustomOfferSubs = (cart = []) => {
  return cart.reduce((subs, { type, items }) => {
    if (type === CartItemTypes.customOffer) {
      return [...subs, ...items.filter(({ type }) => type === CartItemTypes.subscriptionPlan)];
    }

    return subs;
  }, []);
};
export const hasCustomOfferWithSubscription = (cart = []) => extractCustomOfferSubs(cart).length > 0;

export const extractProducts = (cart = []) => cart.filter(({ type }) => type !== CartItemTypes.subscriptionPlan);
export const hasProducts = (cart = []) => extractProducts(cart).length > 0;

export const isCouponCodeAllowed = (cart = [], rebate = 0, xMarketCredit = 0) => {
  return !hasSubscription(cart) && !hasCustomOfferWithSubscription(cart) && rebate === 0 && xMarketCredit === 0;
}

export const extractCartItems = (cart = []) => {
  return cart.reduce((final, item) => {

    if (item.type === CartItemTypes.subscriptionPlan) final[0].push(item);
    else final[1].push(item);

    if (item.type === CartItemTypes.customOffer && item.hasSubscription)
      final[2].push({ ...item.items.find(({ type: itemType }) => itemType === CartItemTypes.subscriptionPlan ), paidFor: item.paidFor });

    return final;
  }, [[], [], []]);
}

export const hasUnPaidProducts  = (cart = []) => {
  const { 1: products } = extractCartItems(cart);
  
  return products.filter(({ _id, paidFor }) => !paidFor.includes(_id)).length > 0;
}

export const hasUnPaidSubscriptions  = (cart = []) => {
  const { 0: subs, 2: customOfferSubs } = extractCartItems(cart);

  if (subs.length > 0) return subs.filter(({ _id, paidFor }) => !paidFor.includes(_id)).length > 0;
  if (customOfferSubs.length > 0) return customOfferSubs.filter(({ _id, paidFor }) => !paidFor.includes(_id)).length > 0;
  else return false;
}

export const getTotalPricesStrArray = (cart = [], coupon = null, installment, rebate, balance, depositUsed, creditUsed) => {
  const [ subscriptionsPlans, products, customOfferSubs ] = extractCartItems(cart);
  let thisPaymentAmount = 0;
  let productTotalStr = '';
  let customOfferSubsTotalStr = '';
  let subsTotalStr = '';
  if (products.length > 0) {
    let totalPrice = products.reduce((total, { price }) => total + price, 0);
    if (coupon && coupon.discount && !isNaN(Number(coupon.discount)) && coupon.discount > 0) {
      const discountedPrice = (totalPrice * coupon.discount) / 100;
      totalPrice -= discountedPrice;
      totalPrice = Number(totalPrice.toFixed(2));
    }

    if (rebate && !isNaN(Number(rebate)) && rebate > 0) {
      totalPrice -= rebate;
      totalPrice = Number(totalPrice.toFixed(2));
    }

    if (balance && !isNaN(Number(balance)) && balance > 0) {
      totalPrice -= balance;
      totalPrice = Number(totalPrice.toFixed(2));
    }

    if (depositUsed && !isNaN(Number(depositUsed)) && depositUsed > 0) {
      totalPrice -= depositUsed;
      totalPrice = Number(totalPrice.toFixed(2));
    }

    if (creditUsed && !isNaN(Number(creditUsed)) && creditUsed > 0) {
      totalPrice -= creditUsed;
      totalPrice = Number(totalPrice.toFixed(2));
    }

    if (coupon && installment && !isNaN(Number(installment.amount))) {
      const owing = Number((totalPrice - Number(installment.amount)).toFixed(2));
      thisPaymentAmount = Number(installment.amount);
      productTotalStr = `$${formatPrice(Number(installment.amount))} (Remaining $${formatPrice(owing)})`;
    } else {
      thisPaymentAmount = Number(totalPrice);
      productTotalStr = `$${formatPrice(totalPrice)} ${(subscriptionsPlans.length > 0 || customOfferSubs.length > 0) ? '+': ''}`;
    }
  }

  if (customOfferSubs.length > 0) {
    const { price, interval } = customOfferSubs[0];
    customOfferSubsTotalStr = `$${formatPrice(price)}/${SubIntervalMap[interval].short} (first ${SubIntervalMap[interval].display} free)`;
  } else if (subscriptionsPlans.length > 0) {
    const { price, interval, trialPeriod } = subscriptionsPlans[0];
    if (trialPeriod !== 0  && trialPeriod !== undefined) {
      subsTotalStr = `${trialPeriod} days free - then $${formatPrice(price)} per ${SubIntervalMap[interval].display}`;
    } else if (subscriptionsPlans[0]._id && subscriptionsPlans[0]._id === FAIR_MARKET) {
      subsTotalStr = `$${formatPrice(price)} - 3 ${SubIntervalMap[interval].display} access`;
    } else {
      subsTotalStr = `$${formatPrice(price)} per ${SubIntervalMap[interval].display}`;
    }
  }

  return [ productTotalStr, customOfferSubsTotalStr, subsTotalStr, thisPaymentAmount ];
}

export const removeAllItemsWithSubs = (searchableProducts = []) => {
  return searchableProducts.filter(({ value }) => {
    if (value.onModel === CartItemTypes.subscriptionPlan) return false;
    else if (value.onModel === CartItemTypes.customOffer && value.hasSubscription) return false;
    return true;
  });
}

export const loginUser = (credentials) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials)
    });

    const { ok, status, ...rest} = await response.json();

    if (ok) resolve(rest)
    else reject(rest)
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const getAllProductItems = () => new Promise(async (resolve, reject) => {
  try {
    const { ok, customOffers, productPackages, products, subscriptionPlans } = await (await fetch(`${API_URL}/order/searchable-items`, { credentials: 'include' })).json();

    if (ok) resolve([ ...customOffers, ...productPackages, ...products, ...subscriptionPlans ]);
    else resolve([]);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const createOrder = (order) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(order)
    });

    const { ok, status, ...rest} = await response.json();

    if (ok) resolve(rest)
    else reject(rest)
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const getOrderCookie = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/auth/order/cookie`, { credentials: 'include' });

    resolve(await response.json());
  } catch (error) {
    console.error(error)
    reject({ error: 'Error getting order cookie' });
  }
});

export const getMyOrder = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/my/order`, { credentials: 'include' });

    resolve(await response.json());
  } catch (error) {
    console.error(error)
    resolve({ ok: false, message: error.message || 'Unknown Error', status: error.status || 500 });
  }
});

export const addProductToOrder = (items) => new Promise(async (resolve,  reject) => {
  try {
    const response = await fetch(`${API_URL}/order/item`, {
      credentials: 'include', method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items),
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeProductFromOrder = (items) => new Promise(async (resolve,  reject) => {
  try {
    const response = await fetch(`${API_URL}/order/item`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items),
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const createPayPalOrder = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/paypal/create`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const createPayPalInstallmentOrder = (orderId) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/${orderId}/paypal/create`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const checkPayPalOrderCapture = (token) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/paypal/capture/check/${token}`, {
      credentials: 'include', method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 504) {
      const result = await response.json();
      resolve(result);
    } else {
      resolve(await checkPayPalOrderCapture(token));
    }
  } catch (error) {
    console.error(error);
    resolve({ ok: false, error });
  }
});

export const checkPayPalSubscriptionCapture = (subscriptionId) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/paypal/subscription/capture/check/${subscriptionId}`, {
      credentials: 'include', method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 504) {
      const result = await response.json();
      resolve(result);
    } else {
      resolve(await checkPayPalSubscriptionCapture(subscriptionId));
    }
  } catch (error) {
    console.error(error);
    resolve({ ok: false, error });
  }
});

export const createPayPalSubscription = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/paypal/subscription/create`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const captureStripeInstallmentPayment = (orderId, source, customer) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/${orderId}/stripe/capture`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, customer }),
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const captureStripePayment = (source, customer) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/stripe/capture`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, customer }),
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const addCouponCode = (code) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/add/code/${code}`, {
      credentials: 'include', method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeCouponCode = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/remove/code`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeRebate = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/remove/rebate`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeTradingBalance = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/remove/trading-balance`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeXMarketWallet = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/remove/xMarketWallet`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const addInstallment = (amount) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/installment`, {
      credentials: 'include', method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount })
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const removeInstallment = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/installment`, {
      credentials: 'include', method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const addNextInstallment = (orderId, amount) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/${orderId}/installment`, {
      credentials: 'include', method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount })
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(rest);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const updatePassword = (email) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/account/password/reset/${email}`, {
      credentials: 'include', method: 'GET',
      // eslint-disable-next-line no-useless-escape
      headers: { 'Content-Type': 'application/json', 'tvi-internal-request': 'm*e;^AFS;9%C8/@?c\w4*Y!x@ttq&7=mG_cfbF[KGF\YPB' },
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) resolve(true);
    else reject(rest);
  } catch (error) {
    console.error(error);
    reject(error);
  }
})

export const ValidateEmail = (mail) =>{
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
    return true
  }
    return false
}


export const validToAddSubscriptionPlan = (rebate, coupon, item) => {
  if (item.onModel === CartItemTypes.subscriptionPlan) {
    if (coupon && coupon.discount && !isNaN(Number(coupon.discount)) && coupon.discount > 0) {
      return false;
    }

    if (rebate && !isNaN(Number(rebate)) && rebate > 0) {
      return false
    }
  }
  return true;
}

export const rebatePayInFull = (orderId) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/rebate/paid`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId })
    });

    const result = await response.json();
    console.log(result.ok);

    if (result.ok) resolve(result);
    else reject(result);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});

export const getSymbolLastPrice = async(symbol) => {
  try {
    const url = `https://datacenter.tradeview.com.au/accurate-data/last-bars/broker/5/${symbol}/M1`
    const res = await fetch(url, {
      method: 'GET',
    });
  
    const response = await res.json();
    return response;
  } catch(error) {
    console.log(error);
    return null;
  }
}

export const fetchConversionRate = async(cryptoType) => {
  let audusdData = [];
  let lastAudUsdString = '';
  let usdCryptoData = [];
  let lastUsdCrptoString = '';

  let audToUsdRate = '';
  let cryptoToUsdRate = '';

  const now = new Date();

  if (cryptoType.includes('USDT')) {
    const audRes = await getSymbolLastPrice('AUDUSD');
    audusdData = audRes.data;
    lastAudUsdString = audRes.lastBarString;
    cryptoToUsdRate = 1;
  } else if (CRYPT_TO_SYMBOLS[cryptoType]) {
    const audRes = await getSymbolLastPrice('AUDUSD');
    audusdData = audRes.data;
    lastAudUsdString = audRes.lastBarString;
    console.log('symbol: ', CRYPT_TO_SYMBOLS[cryptoType]);
    const cryptoRes = await getSymbolLastPrice(CRYPT_TO_SYMBOLS[cryptoType]);
    usdCryptoData = cryptoRes.data;
    lastUsdCrptoString = cryptoRes.lastBarString;
  }

  if (Array.isArray(audusdData) && audusdData.length > 1) {
    const priceOne = audusdData[1];
    let priceTwo = { data: 0, low: 0 };
    if (lastAudUsdString.split('|').length > 1 && lastAudUsdString.split('|')[1].split('\n').length) {
      const priceArray = lastAudUsdString.split('|')[1].split('\n');
      const lastPrice = priceArray[0].split(',');
      priceTwo = { data: Number(lastPrice[1]) * 1000, low: lastPrice[2] }
    }
    // const priceTwo = data[1];
    const lastPrice = Number(priceOne.low);
    const currentPrice = Number(priceTwo.low);
    const lastPriceTime = new Date(priceOne.date);
    const currentPriceTime = new Date(priceTwo.date);

    if (!currentPriceTime || now.getTime() - currentPriceTime.getTime() >= VALID_PRICE_TIME) {
      console.log('Current Price was a day ago');
      audToUsdRate = 'Fail to fetch conversion rate';
    } else if (!lastPriceTime || now.getTime() - lastPriceTime.getTime() >= VALID_PRICE_TIME) {
      console.log('Last Price was a day ago');
      audToUsdRate = 'Fail to fetch conversion rate';
    } else if (!lastPrice || !currentPrice || currentPrice / lastPrice > VALID_PRICE_DIFFER_PERCENT || lastPrice / currentPrice > VALID_PRICE_DIFFER_PERCENT) {
      console.log(`Price changed over ${VALID_PRICE_DIFFER_PERCENT} | Current Price: ${currentPrice} | Last Price: ${lastPrice}`);
      audToUsdRate = 'Fail to fetch conversion rate';
    } else {
      const priceTime = lastPriceTime.getTime();
      const originConvertPrice = lastPrice.toFixed(5);
      // console.log("originConvertPrice", originConvertPrice);
      if (now.getTime() - priceTime > 10 * 60 * 1000) {
        audToUsdRate = Number(originConvertPrice);
      } else {
        audToUsdRate = Number(originConvertPrice);
      }

      audToUsdRate = Number(audToUsdRate) ? Number(audToUsdRate).toFixed(5) : 'Fail to fetch conversion rate';
    }
  } else {
    audToUsdRate = 'Fail to fetch conversion rate';
  }

  if ((Array.isArray(usdCryptoData) && usdCryptoData.length > 1)) {
    const priceOne = usdCryptoData[1];
    let priceTwo = { data: 0, low: 0 };
    if (lastUsdCrptoString.split('|').length > 1 && lastUsdCrptoString.split('|')[1].split('\n').length) {
      const priceArray = lastUsdCrptoString.split('|')[1].split('\n');
      const lastPrice = priceArray[0].split(',');
      priceTwo = { data: Number(lastPrice[1]) * 1000, low: lastPrice[2] }
    }
    // const priceTwo = data[1];
    const lastPrice = Number(priceOne.low);
    const currentPrice = Number(priceTwo.low);
    const lastPriceTime = new Date(priceOne.date);
    const currentPriceTime = new Date(priceTwo.date);

    if (!currentPriceTime || now.getTime() - currentPriceTime.getTime() >= VALID_PRICE_TIME) {
      console.log('Current Price was a day ago');
      cryptoToUsdRate = 'Fail to fetch conversion rate';
    } else if (!lastPriceTime || now.getTime() - lastPriceTime.getTime() >= VALID_PRICE_TIME) {
      console.log('Last Price was a day ago');
      cryptoToUsdRate = 'Fail to fetch conversion rate';
    } else if (!lastPrice || !currentPrice || currentPrice / lastPrice > VALID_PRICE_DIFFER_PERCENT || lastPrice / currentPrice > VALID_PRICE_DIFFER_PERCENT) {
      console.log(`Price changed over ${VALID_PRICE_DIFFER_PERCENT} | Current Price: ${currentPrice} | Last Price: ${lastPrice}`);
      cryptoToUsdRate = 'Fail to fetch conversion rate';
    } else {
      const priceTime = lastPriceTime.getTime();
      const originConvertPrice = lastPrice.toFixed(5);
      console.log("cryptoToUsdRate", cryptoToUsdRate);
      if (now.getTime() - priceTime > 10 * 60 * 1000) {
        cryptoToUsdRate = Number(originConvertPrice) + WEEKEND_CONVERSION_SPREAD;
      } else {
        cryptoToUsdRate = Number(originConvertPrice) + NORMAL_CONVERSION_SPREAD;
      }
      console.log("cryptoToUsdRate after", cryptoToUsdRate);

      cryptoToUsdRate = Number(cryptoToUsdRate) ? Number(cryptoToUsdRate).toFixed(2) : 'Fail to fetch conversion rate';
    }
  } else {
    if (!Number(cryptoToUsdRate)) cryptoToUsdRate = 'Fail to fetch conversion rate';
  }

  return [audToUsdRate, cryptoToUsdRate];
}

export const formatConversionAmount = (amount, numDecimals) => {
  console.log(Math.pow(Number(numDecimals)));
  return (Math.ceil(Number(amount) * Math.pow(10, numDecimals)) / Math.pow(10, numDecimals)).toFixed(numDecimals);
}

export const createCrypoPayment = (data) => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/order/crypto/create`, {
      credentials: 'include', method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...data })
    });

    const result = await response.json();
    console.log(result.ok);

    if (result.ok) resolve(result);
    else reject(result);
  } catch (error) {
    console.error(error);
    reject(error);
  }
});